"use strict";

var _toConsumableArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Graphics = require("../../../graphics");

var solver_1 = require("../../../solver");

var Specification = require("../../../specification");

var axis_1 = require("../axis");

var base_1 = require("./base");

var plot_segment_1 = require("../plot_segment");

exports.curveTerminology = {
  xAxis: "Tangent Axis",
  yAxis: "Normal Axis",
  xMin: "Left",
  xMinIcon: "align/left",
  xMiddle: "Middle",
  xMiddleIcon: "align/x-middle",
  xMax: "Right",
  xMaxIcon: "align/right",
  yMiddle: "Middle",
  yMiddleIcon: "align/y-middle",
  yMin: "Bottom",
  yMinIcon: "align/bottom",
  yMax: "Top",
  yMaxIcon: "align/top",
  dodgeX: "Stack Tangential",
  dodgeXIcon: "sublayout/dodge-x",
  dodgeY: "Stack Normal",
  dodgeYIcon: "sublayout/dodge-y",
  grid: "Grid",
  gridIcon: "sublayout/grid",
  gridDirectionX: "Tangent",
  gridDirectionY: "Normal",
  packing: "Packing",
  packingIcon: "sublayout/packing",
  overlap: "Overlap",
  overlapIcon: "sublayout/overlap"
};

var CurvePlotSegment =
/*#__PURE__*/
function (_plot_segment_1$PlotS) {
  _inherits(CurvePlotSegment, _plot_segment_1$PlotS);

  function CurvePlotSegment() {
    var _this;

    _classCallCheck(this, CurvePlotSegment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CurvePlotSegment).apply(this, arguments));
    _this.attributeNames = ["x1", "x2", "y1", "y2", "tangent1", "tangent2", "normal1", "normal2", "gapX", "gapY", "x", "y"];
    _this.attributes = {
      x1: {
        name: "x1",
        type: Specification.AttributeType.Number
      },
      x2: {
        name: "x2",
        type: Specification.AttributeType.Number
      },
      y1: {
        name: "y1",
        type: Specification.AttributeType.Number
      },
      y2: {
        name: "y2",
        type: Specification.AttributeType.Number
      },
      tangent1: {
        name: "tangent1",
        type: Specification.AttributeType.Number
      },
      tangent2: {
        name: "tangent2",
        type: Specification.AttributeType.Number
      },
      normal1: {
        name: "normal1",
        type: Specification.AttributeType.Number
      },
      normal2: {
        name: "normal2",
        type: Specification.AttributeType.Number
      },
      x: {
        name: "x",
        type: Specification.AttributeType.Number
      },
      y: {
        name: "y",
        type: Specification.AttributeType.Number
      },
      gapX: {
        name: "gapX",
        type: Specification.AttributeType.Number,
        editableInGlyphStage: true
      },
      gapY: {
        name: "gapY",
        type: Specification.AttributeType.Number,
        editableInGlyphStage: true
      }
    };
    return _this;
  }

  _createClass(CurvePlotSegment, [{
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.tangent1 = 0;
      attrs.tangent2 = 360;
      attrs.normal1 = 10;
      attrs.normal2 = 100;
      attrs.x1 = -100;
      attrs.x2 = 100;
      attrs.y1 = -100;
      attrs.y2 = 100;
      attrs.x = attrs.x1;
      attrs.y = attrs.y2;
      attrs.gapX = 4;
      attrs.gapY = 4;
    }
  }, {
    key: "createBuilder",
    value: function createBuilder(solver, context) {
      var props = this.object.properties;
      var config = {
        terminology: exports.curveTerminology,
        xAxisPrePostGap: false,
        yAxisPrePostGap: false
      };
      var builder = new base_1.Region2DConstraintBuilder(this, config, "tangent1", "tangent2", "normal1", "normal2", solver, context);
      return builder;
    }
  }, {
    key: "getCurveArcLength",
    value: function getCurveArcLength() {
      return new Graphics.MultiCurveParametrization(this.object.properties.curve.map(function (c) {
        return new Graphics.BezierCurveParameterization(c[0], c[1], c[2], c[3]);
      })).getLength();
    }
  }, {
    key: "buildConstraints",
    value: function buildConstraints(solver, context) {
      var attrs = this.state.attributes;
      var props = this.object.properties;

      var _solver$attrs = solver.attrs(attrs, ["x1", "y1", "x2", "y2", "tangent1", "tangent2", "normal1", "normal2"]),
          _solver$attrs2 = _slicedToArray(_solver$attrs, 8),
          x1 = _solver$attrs2[0],
          y1 = _solver$attrs2[1],
          x2 = _solver$attrs2[2],
          y2 = _solver$attrs2[3],
          tangent1 = _solver$attrs2[4],
          tangent2 = _solver$attrs2[5],
          normal1 = _solver$attrs2[6],
          normal2 = _solver$attrs2[7];

      var arcLength = this.getCurveArcLength();
      attrs.tangent1 = 0;
      solver.makeConstant(attrs, "tangent1"); // tangent2 = arcLength * (x2 - x1) / 2

      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, tangent2]], [[arcLength / 2, x2], [-arcLength / 2, x1]]); // normal1 = normalStart * (x2 - x1) / 2
      // normal2 = normalEnd * (x2 - x1) / 2

      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, normal1]], [[props.normalStart / 2, x2], [-props.normalStart / 2, x1]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, normal2]], [[props.normalEnd / 2, x2], [-props.normalEnd / 2, x1]]);
    }
  }, {
    key: "buildGlyphConstraints",
    value: function buildGlyphConstraints(solver, context) {
      var builder = this.createBuilder(solver, context);
      builder.build();
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          x2 = attrs.x2,
          y1 = attrs.y1,
          y2 = attrs.y2;
      return {
        type: "rectangle",
        cx: (x1 + x2) / 2,
        cy: (y1 + y2) / 2,
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1),
        rotation: 0
      };
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return [{
        type: "x",
        value: x1,
        attribute: "x1"
      }, {
        type: "x",
        value: x2,
        attribute: "x2"
      }, {
        type: "y",
        value: y1,
        attribute: "y1"
      }, {
        type: "y",
        value: y2,
        attribute: "y2"
      }];
    }
  }, {
    key: "getGraphics",
    value: function getGraphics() {
      var _this$state$attribute = this.state.attributes,
          tangent1 = _this$state$attribute.tangent1,
          tangent2 = _this$state$attribute.tangent2,
          normal1 = _this$state$attribute.normal1,
          normal2 = _this$state$attribute.normal2;
      var g = Graphics.makeGroup([]);
      var props = this.object.properties;
      var cs = this.getCoordinateSystem();

      if (props.xData && props.xData.visible) {
        var axis = new axis_1.AxisRenderer().setAxisDataBinding(props.xData, tangent1, tangent2, false, false).renderCurve(cs, props.xData.side == "opposite" ? normal2 : normal1, props.xData.side == "opposite" ? -1 : 1);
        axis["data-datum"] = JSON.stringify({
          _TYPE: "axis",
          type: "tangent",
          position: base_1.getMatches(props.xData.expression)
        });
        g.elements.push(axis);
      }

      if (props.yData && props.yData.visible) {
        var tr = cs.getLocalTransform(props.yData.side == "opposite" ? tangent2 : tangent1, 0);
        tr = Graphics.concatTransform(cs.getBaseTransform(), tr);

        var _axis = new axis_1.AxisRenderer().setAxisDataBinding(props.yData, normal1, normal2, false, true).renderLine(tr.x, tr.y, tr.angle + 90, props.yData.side == "opposite" ? 1 : -1);

        _axis["data-datum"] = JSON.stringify({
          _TYPE: "axis",
          type: "normal",
          position: base_1.getMatches(props.yData.expression)
        });
        g.elements.push(_axis);
      }

      return g;
    }
  }, {
    key: "getCoordinateSystem",
    value: function getCoordinateSystem() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      var cx = (x1 + x2) / 2,
          cy = (y1 + y2) / 2;
      var scaler = (x2 - x1) / 2;
      return new Graphics.BezierCurveCoordinates({
        x: cx,
        y: cy
      }, new Graphics.MultiCurveParametrization(this.object.properties.curve.map(function (ps) {
        var p = ps.map(function (p) {
          return {
            x: p.x * scaler,
            y: p.y * scaler
          };
        });
        return new Graphics.BezierCurveParameterization(p[0], p[1], p[2], p[3]);
      })));
    }
  }, {
    key: "getDropZones",
    value: function getDropZones() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      var zones = [];
      zones.push({
        type: "region",
        accept: {
          scaffolds: ["polar"]
        },
        dropAction: {
          extendPlotSegment: {}
        },
        p1: {
          x: x1,
          y: y1
        },
        p2: {
          x: x2,
          y: y2
        },
        title: "Convert to Polar Coordinates"
      });
      zones.push({
        type: "region",
        accept: {
          scaffolds: ["cartesian-x", "cartesian-y"]
        },
        dropAction: {
          extendPlotSegment: {}
        },
        p1: {
          x: x1,
          y: y1
        },
        p2: {
          x: x2,
          y: y2
        },
        title: "Convert to Cartesian Coordinates"
      }); // zones.push(
      //     <DropZones.Line>{
      //         type: "line",
      //         p1: { x: cx + radial1, y: cy }, p2: { x: cx + radial2, y: cy },
      //         title: "Radial Axis",
      //         dropAction: {
      //             axisInference: { property: "yData" }
      //         }
      //     }
      // );
      // zones.push(
      //     <DropZones.Arc>{
      //         type: "arc",
      //         center: { x: cx, y: cy },
      //         radius: radial2,
      //         angleStart: attrs.angle1, angleEnd: attrs.angle2,
      //         title: "Angular Axis",
      //         dropAction: {
      //             axisInference: { property: "xData" }
      //         }
      //     }
      // );

      return zones;
    }
  }, {
    key: "getAxisModes",
    value: function getAxisModes() {
      var props = this.object.properties;
      return [props.xData ? props.xData.type : "null", props.yData ? props.yData.type : "null"];
    }
  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var props = this.object.properties;
      var rows = this.parent.dataflow.getTable(this.object.table).rows;
      var x1 = attrs.x1,
          x2 = attrs.x2,
          y1 = attrs.y1,
          y2 = attrs.y2;
      var radius = Math.min(Math.abs(x2 - x1), Math.abs(y2 - y1)) / 2;
      var cx = (x1 + x2) / 2,
          cy = (y1 + y2) / 2;
      var h = [{
        type: "line",
        axis: "y",
        value: y1,
        span: [x1, x2],
        actions: [{
          type: "attribute",
          attribute: "y1"
        }]
      }, {
        type: "line",
        axis: "y",
        value: y2,
        span: [x1, x2],
        actions: [{
          type: "attribute",
          attribute: "y2"
        }]
      }, {
        type: "line",
        axis: "x",
        value: x1,
        span: [y1, y2],
        actions: [{
          type: "attribute",
          attribute: "x1"
        }]
      }, {
        type: "line",
        axis: "x",
        value: x2,
        span: [y1, y2],
        actions: [{
          type: "attribute",
          attribute: "x2"
        }]
      }, {
        type: "point",
        x: x1,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: x2,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: x1,
        y: y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }, {
        type: "point",
        x: x2,
        y: y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }, {
        type: "input-curve",
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        actions: [{
          type: "property",
          property: "curve"
        }]
      }];
      return h;
    }
  }, {
    key: "getPopupEditor",
    value: function getPopupEditor(manager) {
      var builder = this.createBuilder();
      var widgets = builder.buildPopupWidgets(manager);

      if (widgets.length == 0) {
        return null;
      }

      var attrs = this.state.attributes;
      var anchor = {
        x: attrs.x1,
        y: attrs.y2
      };
      return {
        anchor: anchor,
        widgets: _toConsumableArray(widgets)
      };
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var builder = this.createBuilder();
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(CurvePlotSegment.prototype), "getAttributePanelWidgets", this).call(this, manager)), [manager.sectionHeader("Curve Coordinates"), manager.row("Normal", manager.horizontal([1, 0, 1], manager.inputNumber({
        property: "normalStart"
      }), manager.label("-"), manager.inputNumber({
        property: "normalEnd"
      })))], _toConsumableArray(builder.buildPanelWidgets(manager)));
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var r = [];

      if (this.object.properties.xData) {
        r.push(axis_1.buildAxisInference(this.object, "xData"));
      }

      if (this.object.properties.yData) {
        r.push(axis_1.buildAxisInference(this.object, "yData"));
      }

      if (this.object.properties.sublayout.order && this.object.properties.sublayout.order.expression) {
        r.push({
          objectID: this.object._id,
          dataSource: {
            table: this.object.table,
            groupBy: this.object.groupBy
          },
          expression: {
            expression: this.object.properties.sublayout.order.expression,
            property: {
              property: "sublayout",
              field: ["order", "expression"]
            }
          }
        });
      }

      return {
        inferences: r
      };
    }
  }]);

  return CurvePlotSegment;
}(plot_segment_1.PlotSegmentClass);

CurvePlotSegment.classID = "plot-segment.curve";
CurvePlotSegment.type = "plot-segment";
CurvePlotSegment.metadata = {
  displayName: "PlotSegment",
  iconPath: "plot-segment/curve",
  creatingInteraction: {
    type: "rectangle",
    mapping: {
      xMin: "x1",
      yMin: "y1",
      xMax: "x2",
      yMax: "y2"
    }
  }
};
CurvePlotSegment.defaultProperties = {
  marginX1: 0,
  marginY1: 0,
  marginX2: 0,
  marginY2: 0,
  visible: true,
  sublayout: {
    type: "dodge-x",
    order: null,
    ratioX: 0.1,
    ratioY: 0.1,
    align: {
      x: "start",
      y: "start"
    },
    grid: {
      direction: "x",
      xCount: null,
      yCount: null
    }
  },
  curve: [[{
    x: -1,
    y: 0
  }, {
    x: -0.25,
    y: -0.5
  }, {
    x: 0.25,
    y: 0.5
  }, {
    x: 1,
    y: 0
  }]],
  normalStart: -0.2,
  normalEnd: 0.2
};
exports.CurvePlotSegment = CurvePlotSegment;